import React from 'react';
import Icon from '../../../components/AppIcon';

const ProcessSteps = ({ dealership }) => {
  // 🔍 DIAGNOSTIC LOGGING
  console.log('🎨 ProcessSteps - Colors:', {
    primary: dealership?.ciPrimaryColor,
    secondary: dealership?.ciSecondaryColor
  });

  const voucherValue = dealership?.voucherValue || 150;
  const voucherCurrency = dealership?.voucherCurrency || 'Euro';

  const steps = [
    {
      number: '1',
      icon: 'FileText',
      title: 'Formular ausfüllen',
      description: 'Tragen Sie Ihre Daten ein und laden Sie den Fahrzeugschein hoch.'
    },
    {
      number: '2',
      icon: 'CheckCircle2',
      title: 'Wir kümmern uns um alles',
      description: 'Wir prüfen die Angaben und wickeln das CO₂‑Zertifikat für Sie ab.'
    },
    {
      number: '3',
      icon: 'Gift',
      title: `${voucherValue} ${voucherCurrency} Gutschein erhalten`,
      description: 'Nach erfolgreicher Prüfung senden wir Ihnen den Wertgutschein zu.'
    },
    {
      number: '4',
      icon: 'Store',
      title: 'Gutschein beim Partner einlösen',
      description: 'Einfach bei Ihrem nächsten Kauf oder Termin vorzeigen.'
    }
  ];

  return (
    <section className="py-12 md:py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-4">
            So funktioniert's
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            In nur 4 einfachen Schritten zu Ihrem {voucherValue} {voucherCurrency} Wertgutschein
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps?.map((step, index) => (
            <div key={index} className="relative">
              <div className="flex flex-col items-center text-center">
                <div className="relative mb-4">
                  <div 
                    className="w-16 h-16 rounded-full flex items-center justify-center shadow-card"
                    style={dealership?.ciPrimaryColor ? { 
                      backgroundColor: dealership?.ciPrimaryColor,
                      border: `4px solid ${dealership?.ciPrimaryColor}`,
                      boxShadow: `0 4px 12px ${dealership?.ciPrimaryColor}40`
                    } : { backgroundColor: 'var(--color-primary)' }}
                  >
                    <Icon name={step?.icon} size={28} color="#ffffff" />
                  </div>
                  <div 
                    className="absolute -top-2 -right-2 w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-lg"
                    style={dealership?.ciSecondaryColor ? { 
                      backgroundColor: dealership?.ciSecondaryColor,
                      border: `3px solid ${dealership?.ciSecondaryColor}`,
                      boxShadow: `0 2px 8px ${dealership?.ciSecondaryColor}60`
                    } : dealership?.ciPrimaryColor ? { 
                      backgroundColor: dealership?.ciPrimaryColor, 
                      filter: 'brightness(0.7)',
                      border: `3px solid ${dealership?.ciPrimaryColor}`,
                      boxShadow: `0 2px 8px ${dealership?.ciPrimaryColor}40`
                    } : { backgroundColor: 'var(--color-secondary)' }}
                  >
                    {step?.number}
                  </div>
                </div>
                
                <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
                  {step?.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {step?.description}
                </p>
              </div>

              {index < steps?.length - 1 && (
                <div 
                  className="hidden lg:block absolute top-8 left-full w-full h-0.5 -translate-x-1/2"
                  style={dealership?.ciPrimaryColor ? { 
                    backgroundColor: `${dealership?.ciPrimaryColor}80`
                  } : { backgroundColor: 'var(--color-border)' }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;